import { StoryTranslationType } from "../../features/story.types";

export const story: StoryTranslationType = {
  success: {
    charactersSaved: "Personajes Guardados",
    charactersAddedToLibrary: "Personajes Añadidos a la Biblioteca"
  },
  storySetup: {
    titles: {
      new: "Crear Nueva Historia",
      edit: "Editar Historia",
      continue: "Continuar Historia"
    },
    basicInfo: {
      storyTitle: "Título de la Historia",
      titlePlaceholder: "Ingrese un título cautivador para su historia",
      silverLining: "Descripción de la Historia",
      descriptionPlaceholder: "Describa brevemente de qué trata su historia",
      genre: "Género",
      selectGenre: "Seleccionar género",
      environment: "Entorno",
      selectEnvironment: "Seleccionar entorno",
      theme: "Tema",
      storyLength: "Longitud de la Historia",
      storyLengthWithNumberOfPages: "Longitud de la Historia (Número de Páginas)",
      selectLength: "Seleccionar longitud",
      aiSuggest: "Sugerencia de IA",
      missingValues: "Valores Faltantes",
      fillRequired: "Por favor complete todos los campos requeridos",
      titleGenerated: "Título Generado",
      generationError: "Error de Generación",
      tryAgain: "Intentar de Nuevo",
      addCustomGenre: "Añadir Género Personalizado",
      addCustomEnvironment: "Añadir Entorno Personalizado",
      addCustomTheme: "Añadir Tema Personalizado",
      autoGenerate: "Generar Automáticamente",
      formDataGenerated: "Datos del Formulario Generados",
      dataUpdated: "Datos Actualizados",
      formDataEnhanced: "Datos del Formulario Mejorados",
      noEnhancementsNeeded: "No se Necesitan Mejoras",
      formDataUpToDate: "Los datos del formulario están actualizados",
      needSomeInfo: "Necesitamos algo de información para comenzar"
    },
    genres: {
      kidsStory: "Historia Infantil",
      fantasy: "Fantasía",
      romance: "Romance",
      adventure: "Aventura",
      contemporary: "Contemporáneo",
      historicalFiction: "Ficción Histórica",
      scienceFiction: "Ciencia Ficción",
      mystery: "Misterio",
      horror: "Terror",
      superhero: "Superhéroe",
      thriller: "Thriller"
    },
    environments: {
      urbanCity: "Ciudad Urbana",
      medievalCastle: "Castillo Medieval",
      spaceStation: "Estación Espacial",
      forest: "Bosque",
      desert: "Desierto",
      ocean: "Océano",
      mountain: "Montaña",
      smallTown: "Pueblo Pequeño",
      futuristicMetropolis: "Metrópolis Futurista",
      underwaterKingdom: "Reino Submarino",
      hauntedMansion: "Mansión Embrujada",
      mountainCavern: "Caverna Montañosa",
      dragonLair: "Guarida del Dragón",
      researchLaboratory: "Laboratorio de Investigación",
      futureCommunications: "Comunicaciones Futuristas",
      magicalLibrary: "Biblioteca Mágica",
      rainyNight: "Noche Lluviosa",
      ancientTemple: "Templo Antiguo"
    },
    storyLengths: {
      short: "Corta",
      medium: "Media",
      long: "Larga",
      natural: "Natural"
    },
    characters: {
      name: "Nombre",
      description: "Descripción",
      title: "Personajes",
      browseCharacters: "Explorar Personajes",
      makePublic: "Hacer Público"
    },
    character: {
      name: "Nombre del Personaje",
      namePlaceholder: "Ingrese nombre del personaje",
      role: "Rol del Personaje",
      selectRole: "Seleccionar rol",
      description: "Descripción del Personaje",
      descriptionPlaceholder: "Describa a su personaje",
      create: "Crear Personaje",
      update: "Actualizar Personaje",
      roles: {
        protagonist: "Protagonista",
        antagonist: "Antagonista",
        deuteragonist: "Deuteragonista",
        mentor: "Mentor",
        comic_relief: "Alivio Cómico",
        mysterious: "Misterioso",
        love_interest: "Interés Amoroso",
        anti_hero: "Antihéroe",
        sidekick: "Compañero",
        shapeshifter: "Cambiaformas",
        guardian: "Guardián",
        catalyst: "Catalizador"
      }
    },
    themeSection: {
      title: "Tema"
    },
    themeOptions: {
      friendship: "Amistad",
      love: "Amor",
      betrayal: "Traición",
      redemption: "Redención",
      growth: "Crecimiento",
      power: "Poder",
      justice: "Justicia",
      family: "Familia",
      courageBravery: "Coraje y Valentía",
      magicMythology: "Magia y Mitología",
      survival: "Supervivencia",
      warConflict: "Guerra y Conflicto",
      freedomRebellion: "Libertad y Rebelión",
      violenceRevenge: "Violencia y Venganza",
      passionEroticism: "Pasión y Erotismo",
      quest: "Búsqueda",
      ancientWisdom: "Sabiduría Antigua",
      timeTravel: "Viaje en el Tiempo",
      technology: "Tecnología",
      paradox: "Paradoja",
      knowledge: "Conocimiento",
      magic: "Magia",
      discovery: "Descubrimiento",
      identity: "Identidad",
      sacrifice: "Sacrificio",
      transformation: "Transformación"
    },
    buttons: {
      create: "Crear Historia",
      update: "Actualizar Historia"
    },
    success: {
      title: "Configuración de Historia Completada",
      description: "Tu historia ha sido creada exitosamente y está lista para tu viaje creativo."
    },
    failure: {
      title: "Fallo en la Configuración de Historia",
      description: "Hubo un error inesperado al crear tu historia. Por favor intenta de nuevo."
    },
  },
  story: {
    parts: "Partes",
    part: "Parte",
    continueStory: "Continuar Historia",
    print: "Imprimir",
    generatingSummary: "Generando Resumen",
    generatingContinuation: "Generando Continuación",
    pleaseWait: "Por favor espere...",
    backToDashboard: "Volver al Panel",
    extractCharacters: "Extraer Personajes",
    foundCharacters: "Personajes Encontrados",
    addSelectedCharacters: "Añadir Personajes Seleccionados",
    share: "Compartir",
    viewEntire: "Ver Historia Completa",
    viewPaginated: "Ver Paginada",
    tooltips: {
      upgradeToContinue: "Actualiza para continuar historias",
      upgradeToShare: "Actualiza para compartir historias",
      upgradeToExtract: "Actualiza para extraer personajes"
    },
    ratings: {
      submitted: "Calificación enviada",
      thankYou: "¡Gracias por calificar esta historia!",
      error: "Error",
      failedToSubmit: "No se pudo enviar la calificación"
    },
    sharing: {
      dialogTitle: "Compartir tu historia",
      dialogDescription: "Elige dónde quieres compartir tu historia",
      privacy: "Privacidad de la Historia",
      privacyLevels: {
        private: "Privada",
        public: "Pública",
        friends: "Solo Amigos"
      },
      platform: "Plataforma",
      selectPlatform: "Seleccionar plataforma",
      customMessage: "Mensaje Personalizado",
      customMessagePlaceholder: "Añade un mensaje a tu compartido...",
      shareButton: "Compartir Historia",
      successTitle: "Historia compartida exitosamente",
      successMessage: "Tu historia ha sido compartida en {{platform}}",
      authRequired: "Autenticación requerida",
      authMessage: "Por favor inicia sesión para compartir historias."
    },
    upgrade: {
      title: "Actualización Requerida",
      continueDescription: "Actualiza tu cuenta para crear secuencias de historia.",
      continueFeature: "Crea secuencias de historia con una suscripción premium",
      shareDescription: "Actualiza tu cuenta para compartir historias.",
      shareFeature: "Comparte historias con una suscripción básica",
      extractDescription: "Actualiza tu cuenta para extraer personajes.",
      extractFeature: "Extrae personajes con una suscripción premium",
      upgradeButton: "Actualizar Ahora"
    }
  },
  storyEditor: {
    navigation: {
      previousPage: "Página Anterior",
      continue: "Continuar",
      returnToDashboard: "Regresar al Panel",
      page: "Página",
      of: "de",
      remainingPages: "Paginas Restantes",
    },
    input: {
      customResponse: "Respuesta Personalizada"
    },
    choices: {
      yourChoice: "Tu Elección"
    },
    completedStory: {
      title: "Historia Completada",
      description: "¡Tu historia ha llegado a su conclusión!",
    },
  },
  imageGeneration:{
    ready: "Listo",
    imageReady: "Imagen Lista",
    insufficientCredits: "Créditos Insuficientes",
    needMoreCredits: "Necesitas Más Créditos",
    failed: "Fallido",
    processing: "Procesando",
    pleaseWait: "Por favor espera",
    unexpectedError: "Error Inesperado",
    generateImage: "Generar Imagen",
    costsCredits: "Cuesta Créditos",
    generatingImage: "Generando Imagen",
    credits: "créditos",
    creditsLabel: "créditos",
    selectImage: "Seleccionar Imagen",
    selectImageDescription: "Selecciona una imagen para representar el evento",
    selectPreferred: "Seleccionar Imagen Preferida",
    contentNotFound: "Contenido No Encontrado",
    saved: "Imagen Guardada",
    imageSaved: "Imagen Guardada",
    partialSuccess: "Éxito Parcial",
    someImagesFailed: "Algunas imágenes fallaron al generarse",
  },
  audioGeneration: {
    insufficientCredits: "Créditos Insuficientes",
    generateAudio: "Generar Audio",
    generatingAudio: "Generando Audio",
    pleaseWait: "Por favor espera",
    failed: "Fallido",
    success: "Éxito",
    audioReady: "Audio Listo",
    audioAvailable: "Audio Disponible"
  },
  storyRewrite:{
    rewritesLeft: "Reescrituras Restantes",
    rewriteStory: "Reescribir Historia",
    rewriteComplete: "Reescritura de Historia Completada",
    refreshingContent: "Actualizando Contenido",
    refreshError: "Error de Actualización",
    refreshErrorMessage: "Ocurrió un error inesperado al actualizar la historia. Por favor inténtalo de nuevo.",
    noRewritesLeft: "No quedan reescrituras",
    tryPageRefresh: "Intenta refrescar la página",
  },
  loadingMessages: {
    craftingTheNextChapter: "Creando el Próximo Capítulo",
    weavingThePlotTwists: "Weaving the Plot Twists",
    yourAdventureIsAboutToUnfold: "Tu Aventura Está a Punto de Desplegarse",
    developingTheCharacters: "Desarrollando los Personajes",
    imaginingNewPossibilities: "Imaginando Nuevas Posibilidades",
  },
};
